module.exports = __webpack_public_path__ + "static/logo-0e56ddd0198558bf0e0853f64793d3e3.png";